<template>
  <div class="file-uploader">
    <div class="upload-list" v-for="file in uploadList" :key="file.uid">
      <template v-if="file.status === 'success'">
        <slot :file="file" name="placeholder"></slot>

        <div class="upload-list-cover">
          <span v-if="showThumb(file)" @click.stop="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>

          <span @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>

          <div class="file-name">{{ file.name }}</div>
        </div>
      </template>

      <el-progress v-else style="line-height: 100px" :text-inside="true" :stroke-width="18" :percentage="file.percentage"></el-progress>
    </div>

    <el-upload
      v-if="props.multiple || uploadList.length < 1"
      ref="uploadRef"
      :action="uploadUrl"
      :show-file-list="false"
      :on-success="handleSuccess"
      :on-change="handleChange"
      :file-list="uploadList"
      :auto-upload="props.autoUpload"
      :multiple="props.multiple"
      drag
      with-credentials
      :before-upload="props.beforeUpload"
    >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>

    <el-dialog title="素材预览" width="420px" v-if="dialogVisible" :visible.sync="dialogVisible" destroy-on-close>
      <div style="text-align: center">
        <img v-if="previewType === 1" style="max-width: 320px; max-height: 320px" width="100%" :src="dialogPreviewUrl" alt="" />
        <video
          v-if="previewType === 2"
          style="width: 320px; height: 320px"
          controls
          autoplay
          :src="dialogPreviewUrl"
          width="107px"
          height="107px"
        >
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Message } from 'view-design'
import { HOST_API } from '@/api/config'
const uploadUrl = `${HOST_API}/api/ptom/imageInfo/upload`
const dialogVisible = ref(false)
const dialogPreviewUrl = ref('')
const previewType = ref(1)

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  beforeUpload: {
    type: Function,
    default: () => {}
  },
  autoUpload: {
    type: Boolean,
    default: true
  },
  multiple: {
    type: Boolean,
    default: true
  }
})
const uploadRef = ref(null)
// eslint-disable-next-line
const emits = defineEmits(['input', 'change'])
const uploadList = computed({
  get() {
    return props.value
  },
  set(val) {
    emits('change', val)
    emits('input', val)
  }
})

function handlePictureCardPreview(file) {
  const { raw, response } = file
  dialogPreviewUrl.value = response.data.url
  previewType.value = raw.type.startsWith('image') ? 1 : 2
  dialogVisible.value = true
}

function handleRemove(file) {
  uploadList.value = uploadList.value.filter((ret) => ret.uid !== file.uid)
}

function handleSuccess(res, file) {
  if (res.code !== 200) {
    Message.error(file.name + ',上传失败,' + res.msg)
  }
}

let gap = null
function handleChange(file, fileList) {
  // 防抖
  if (gap) {
    clearTimeout(gap)
  }
  gap = setTimeout(() => {
    uploadList.value = fileList
    gap = null
  }, 1000)
}

/**
 * @description: 判断是否是图片,可点击预览
 * @param {*} file
 * @return {*}
 */
function showThumb(file) {
  const { type } = file.raw
  if (
    ['image/jpeg', 'image/png', 'video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/webm', 'video/ogg'].includes(
      type
    )
  ) {
    return true
  }
  return false
}
// eslint-disable-next-line
defineExpose({
  submit: () => uploadRef.value.submit()
})
</script>

<style scoped lang="scss">
.file-uploader {
  display: flex;
  flex-wrap: wrap;
  &.preview-slot {
    display: block;
  }
}

::v-deep .el-upload {
  .el-icon-plus {
    line-height: 100px;
    font-size: 22px;
  }

  .el-upload-dragger {
    width: 100px;
    height: 100px;
  }
}

.upload-list {
  display: inline-block;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;

  img {
    width: 100%;
    height: 100%;
  }
}

.upload-list-cover {
  line-height: 60px;
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;

  .file-name {
    line-height: 20px;
    color: #fff;
  }
}

.upload-list:hover .upload-list-cover {
  display: block;
}

.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
